import React from 'react';
import ApprovalLineModal from '../../../../components/common/form/modal/ApprovalLineModal';

const InvoiceLinModalConatiner = ({
  link,
  title,
  open,
  handleClose,
  handleSubmit,
  approvalLines,
  apprUuid,
}) => {
  if (!approvalLines) {
    return <div>로딩중</div>;
  }

  return (
    <ApprovalLineModal
      link={link}
      title={title}
      open={open}
      handleClose={handleClose}
      apprUuid={apprUuid}
      approvalLines={approvalLines}
      handleSubmit={handleSubmit}
    />
  );
};

export default InvoiceLinModalConatiner;
